import distributionChannelsChangelog from "../../../../../pages/distribution-channels-api/docs/changelog-distribution-channels.json5";
import * as React from 'react';
export default {
  distributionChannelsChangelog,
  React
};